<div
  class="position-relative d-flex flex-column align-items-center justify-content-center my-auto p-3"
>
  <img
    *ngIf="!isUserLoggedIn()"
    class="position-relative z-1 tangoe-logo-error-page"
    src="./assets/images/tangoe_logo.png"
    alt="{{ 'tangoe_logo' | translate }}"
  />
  <h2 class="position-relative z-1 text-center text-nowrap mb-3">{{ title }}</h2>

  <p class="position-relative z-1 w-auto d-inline-block text-center error-text">
    {{ main }}<br />
    {{ main2 }}
  </p>
  <p *ngIf="hint" class="position-relative z-1 w-auto d-inline-block text-center mt-2 error-text">
    {{ hint }}
  </p>

  <button
    *ngIf="showReturnToDashboardButton()"
    class="position-relative z-1 btn btn-primary mt-3"
    (click)="navigateToDashboard()"
  >
    <span>
      {{ 'return_to_dashboard' | translate }}
    </span>
  </button>

  <button
    *ngIf="showNavigateToLoginPageButton()"
    class="position-relative z-1 btn btn-primary mt-3"
    (click)="navigateToLogin()"
  >
    <span>
      {{ 'return_to_login' | translate }}
    </span>
  </button>
  <span
    *ngIf="error_code !== undefined"
    class="position-absolute z-0 top-50 start-50 translate-middle error-code"
  >
    {{ error_code }}
  </span>
</div>
